module.exports = __webpack_public_path__ + "img/distance-40cm.be98f424.svg";